module.exports = __webpack_public_path__ + "static/media/kings.e9b5c23d.png";